import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../constants/breakpoints";
import {colors} from "../../../constants/colors";
import checkIconRed from "../../../resources/images/alert-circle.svg";

const styles = createUseStyles(theme => ({
  modalContent: {
    margin: "20px 0 0 0"
  },
  footerBtns: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  checkbox: {
    marginRight: "12px"
  },
  wrapper: {
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      display: "grid"
    }
  },
  inputWrapper: {
    display: "flex",
    gap: "10px",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      width: "480px"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    }
  },
  firstBtn: {
    marginTop: "26px !important"
  },
  inviteAuthorisedModal: {
    width: "644px",
    maxWidth: "unset",
    "& .modal-header": {
      padding: "24px 24px 20px 24px",
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px"
      }
    },
    "& .modal-title": {
      padding: "0 24px",
      fontSize: "18px",
      fontWeight:"600",
      lineHeight:"28px",
    },
    "& .body, .modal-body": {
      fontSize: "14px",
      fontWeight:"400",
      lineHeight:"20px",
    },
    "& .modal-body": {
      padding: "8px 24px",

    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    }
  },

  scrollableContainer: {
    maxHeight: "250px",
    overflowY: "auto",
    gap: "20px"
  },
  btnContainer:{
    marginTop:"32px",
    marginBottom:"12px",
  },

  iconContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "37px",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      marginTop: 0
    }
  },

  colContainer: {
    paddingLeft: "20px"
  },

  inputContainer:{
    display:"flex",
    flexDirection:"column",
    "& input":{
      height: "40px",
      width: "100%",
      border: "1px solid " + colors.darkGrey,
      borderRadius: "8px",
      padding: "10px 14px",
      fontSize: "16px",
      color: colors.inactiveGrey,
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      "&:focus": {
        outline: "none"
      }
    },
    "& .input-error":{
      border: "1px solid " + colors.red,
      backgroundSize: "16px 16px",
      backgroundPosition: "right",
      backgroundRepeat: "no-repeat",
      backgroundOrigin:"content-box",
      backgroundImage: `url(${checkIconRed})`
    },
  },
  inputAndBtnContainer: {
    width: "100%",
    minWidth: "320px",
    extend: "inputContainer",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      minWidth: "100%"
    }
  },
  inputText: {
    fontSize: "16px",
    fontWeight:"400",    
    color: colors.lightBlack,
    height: "44px",
    display: "flex",
    alignItems: "center"
  },
  cancelBtn: {
    width:"100%",
    justifyContent:"center",
    fontSize: "16px",
    fontWeight:"600",
    lineHeight:"20px",
    fontFamily: theme.fontFamily,
  },
  createBtn: {
    width:"100%",
    justifyContent:"center",
    fontSize: "16px",
    fontWeight:"600",
    lineHeight:"20px",
    fontFamily: theme.fontFamily,
  },
  disableBtn: {
    "& path": {
      stroke: colors.darkGrey
    }
  },
  colCancel:{
    padding:"0px",
    marginRight:"6px"
  },
  colRemove:{
    padding:"0px"
  },
  label:{
    fontSize: "14px",
    fontWeight:"500",
    lineHeight:"20px",
    color: colors.grey,
    marginBottom:"6px"
  },
  hideLabel: {
    display: "none",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      fontSize: "14px",
      fontWeight:"500",
      lineHeight:"20px",
      color: colors.grey,
      marginBottom:"6px",
      display: "block"
    }
  },
  error: {
    color: colors.red,
    fontSize: "14px",
    textAlign: "left",
    "& p": {
      margin: 0,
    }
  },
  deleteBtn:{
    border:"none",
    padding: "8px",
    height: "fit-content",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      marginTop: "26px !important"
    },
    "& span": {
      marginRight: "0",
    },
    "&:hover": {
      outline: "none",
      border:"none",
    },
    "&:focus": {
      outline: "none",
      border:"none",
    }
  },
  helpIcon: {
    width: "16px",
    height: "16px",
    marginLeft: "8px",
    cursor: "pointer",
    padding: "unset",
    "&:hover": {
      "& path": {
        stroke: colors.inactiveGrey
      }
    },
  },
  tooltip: {
    "& .tooltip-inner": {
      maxWidth: "320px !important",
      fontSize: "12px",
      padding: "12px",
      textAlign:"start",
      borderRadius: "8px",
    },
    "& .tooltip-arrow": {
      display: "none"
    }
  },
  tooltipTitle: {
    fontSize: "12px",
    fontWeight:"600",
    lineHeight:"18px",
    marginBottom: "4px"
  }
}));

export default styles;
